(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riell-store-style"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('riell-store-style')) return;
  class RiellStoreStyle extends HTMLElement {
    connectedCallback() {
      document.documentElement.classList.add('riell-store-theme');
      const data = this.querySelector('[data-store-links]');
      if (!data) return;
      try { this.links = JSON.parse(data.textContent); } catch { return; }
      this.abort?.abort();
      this.abort = new AbortController();
      const install = () => this.install();
      this.install();
      document.addEventListener('DOMContentLoaded', install, {once:true,signal:this.abort.signal});
      document.addEventListener('shopify:section:load', install, {signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
    install() {
      for (const list of document.querySelectorAll('.header__inline-menu > ul, .menu-drawer__navigation > ul')) {
        const mobile = Boolean(list.closest('.menu-drawer'));
        const key = JSON.stringify(this.links);
        if (list.dataset.riellLinks === key) continue;
        const items = this.links.map(link => {
          const item = document.createElement('li');
          const anchor = document.createElement('a');
          anchor.href = link.url;
          anchor.textContent = link.label;
          anchor.className = mobile ? 'menu-drawer__menu-item list-menu__item link link--text focus-inset' : 'header__menu-item list-menu__item link link--text focus-inset';
          const url = new URL(link.url, location.origin);
          if (url.pathname === location.pathname) anchor.setAttribute('aria-current','page');
          item.appendChild(anchor);
          return item;
        });
        list.replaceChildren(...items);
        list.dataset.riellLinks = key;
      }
    }
  }
  customElements.define('riell-store-style', RiellStoreStyle);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["riell-vinyl-explorer"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('riell-vinyl-viewer')) return;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const gallery = [
    ['coverFront', 'Front cover'], ['coverBack', 'Back cover'],
    ['innerFront', 'Inner sleeve — front'], ['innerBack', 'Inner sleeve — back'],
    ['labelA', 'Record label — Side A'], ['labelB', 'Record label — Side B']
  ];
  class RiellVinylViewer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const data = this.querySelector('[data-rv-assets]');
      if (!data && !this.assets) return;
      if (data) {
        try { this.assets = JSON.parse(data.textContent); } catch { return; }
      }
      if (!gallery.every(([key]) => this.assets[key])) return;
      this.initialized = true;
      this.abort = new AbortController();
      this.pose = {s: 0, d: 0, yaw: -18, pitch: -7};
      this.step = 0; this.token = 0; this.playing = false;
      this.reducedQuery = matchMedia('(prefers-reduced-motion: reduce)');
      this.reduced = this.reducedQuery.matches;
      this.innerHTML = `
      <section class="rv-shell rv-loading" aria-label="Explore the Hymns For The Bitter vinyl">
        <div class="rv-heading">
          <div><p class="rv-kicker">RIELL</p><h2>Hymns For The Bitter</h2></div>
          <p class="rv-format">12″ VINYL</p>
        </div>
        <div class="rv-stage" role="img" aria-label="Interactive 3D vinyl. Use the controls to open the sleeve or see the back. Drag horizontally to rotate.">
          <div class="rv-viewer">
            <div class="rv-jacket rv-piece"></div>
            <div class="rv-inner-stack rv-piece">
              <div class="rv-inner rv-piece"></div>
              <div class="rv-record rv-piece"></div>
            </div>
          </div>
          <p class="rv-status">Loading artwork…</p>
        </div>
        <div class="rv-toolbar">
          <div class="rv-steps" role="group" aria-label="Packaging view">
            <button type="button" class="rv-step" data-step="0" aria-pressed="true">Cover</button>
            <button type="button" class="rv-step" data-step="1" aria-pressed="false">Inner sleeve</button>
            <button type="button" class="rv-step" data-step="2" aria-pressed="false">Full set</button>
          </div>
          <div class="rv-actions">
            <button type="button" class="rv-action rv-primary rv-play">Play reveal</button>
            <button type="button" class="rv-action rv-flip">See back</button>
            <button type="button" class="rv-action rv-pack">Open vinyl</button>
          </div>
        </div>
        <div class="rv-footer">
          <p class="rv-hint">Drag to rotate · Tap artwork to look closer</p>
          <button type="button" class="rv-detail">View artwork</button>
        </div>
        <p class="rv-sr rv-announcement" aria-live="polite"></p>
      </section>
      <dialog class="rv-dialog" aria-label="Vinyl artwork close-up">
        <div class="rv-dialog-head">
          <h3 class="rv-gallery-title">Front cover</h3>
          <button type="button" class="rv-action rv-close">Close</button>
        </div>
        <img class="rv-detail-image" alt="" width="1300" height="1300">
        <div class="rv-dialog-nav">
          <button type="button" class="rv-action rv-previous">Previous</button>
          <span class="rv-counter">1 / 6</span>
          <button type="button" class="rv-action rv-next">Next</button>
        </div>
      </dialog>`;
      this.q = selector => this.querySelector(selector);
      this.stage = this.q('.rv-stage');
      this.viewer = this.q('.rv-viewer');
      this.jacket = this.q('.rv-jacket');
      this.inner = this.q('.rv-inner');
      this.stack = this.q('.rv-inner-stack');
      this.record = this.q('.rv-record');
      this.dialog = this.q('.rv-dialog');
      this.buildModel();
      this.bindEvents();
      this.resize = new ResizeObserver(() => this.draw());
      this.resize.observe(this.stage);
      this.draw();
      Promise.all(gallery.map(([key]) => new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = this.assets[key];
      }))).then(results => {
        if (!this.isConnected) return;
        this.q('.rv-shell').classList.remove('rv-loading');
        if (results.every(Boolean)) this.updateControls();
        else {
          this.q('.rv-status').textContent = 'Some artwork could not load. Please refresh.';
          this.q('.rv-announcement').textContent = 'Some artwork could not load.';
        }
      });
    }
    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.resize?.disconnect();
      this.initialized = false;
    }
    element(parent, className, style = {}) {
      const el = document.createElement('div');
      el.className = className;
      // Dawn hides empty divs. Model surfaces paint via backgrounds, so keep them visible.
      Object.assign(el.style, {display: 'block'}, style);
      parent.appendChild(el);
      return el;
    }
    texture(el, key) {
      if (this.assets[key]) el.style.backgroundImage = 'url(' + JSON.stringify(this.assets[key]) + ')';
    }
    plane(parent, w, h, depth, reverse, key, inside = false) {
      const plane = this.element(parent, 'rv-plane ' + (inside ? 'rv-inside' : 'rv-outside'), {
        width: w + 'px', height: h + 'px', left: -w / 2 + 'px', top: -h / 2 + 'px',
        transform: (reverse ? 'rotateY(180deg) ' : '') + 'translateZ(' + depth + 'px)'
      });
      if (key) {
        this.texture(plane, key);
        plane.dataset.rvArt = key;
        this.element(plane, 'rv-sheen');
      }
      return plane;
    }
    pocket(parent, w, h, depth, front, back, opening, spine) {
      this.element(parent, 'rv-shadow');
      this.plane(parent, w, h, depth / 2, false, front);
      this.plane(parent, w, h, depth / 2, true, back);
      this.plane(parent, w, h, -depth / 2 + .16, false, null, true);
      this.plane(parent, w, h, -depth / 2 + .16, true, null, true);
      const walls = {
        left: {width: depth + 'px', height: h + 'px', left: -w / 2 - depth / 2 + 'px', top: -h / 2 + 'px', transform: 'rotateY(-90deg)'},
        right: {width: depth + 'px', height: h + 'px', left: w / 2 - depth / 2 + 'px', top: -h / 2 + 'px', transform: 'rotateY(90deg)'},
        top: {width: w + 'px', height: depth + 'px', left: -w / 2 + 'px', top: -h / 2 - depth / 2 + 'px', transform: 'rotateX(90deg)'},
        bottom: {width: w + 'px', height: depth + 'px', left: -w / 2 + 'px', top: h / 2 - depth / 2 + 'px', transform: 'rotateX(-90deg)'}
      };
      for (const [edge, style] of Object.entries(walls)) {
        if (edge === opening) continue;
        const wall = this.element(parent, 'rv-wall', style);
        if (edge === 'left' && spine) this.texture(wall, spine);
      }
    }
    buildModel() {
      // Model units follow millimetres; preserve the 3 mm cover spine and thin paper.
      this.pocket(this.jacket, 315, 318, 3, 'coverFront', 'coverBack', 'right', 'spine');
      this.pocket(this.inner, 309, 304, 1.7, 'innerFront', 'innerBack', 'top');
      for (const z of [-.5, 0, .5]) this.element(this.record, 'rv-rim', {transform: 'translateZ(' + z + 'px)'});
      for (const [reverse, key] of [[false, 'labelA'], [true, 'labelB']]) {
        const face = this.element(this.record, 'rv-disc', {
          transform: (reverse ? 'rotateY(180deg) ' : '') + 'translateZ(.65px)'
        });
        face.dataset.rvArt = key;
        // Separate surface avoids Firefox flattening children of a masked disc.
        // Keep labels between the disc face (.65) and the sleeve wall (.85).
        const label = this.element(this.record, 'rv-label', {
          transform: (reverse ? 'rotateY(180deg) ' : '') + 'translateZ(.7px)'
        });
        label.dataset.rvArt = key;
        this.texture(label, key);
      }
    }
    on(target, name, handler) {
      target.addEventListener(name, handler, {signal: this.abort.signal});
    }
    bindEvents() {
      this.querySelectorAll('[data-step]').forEach(button => {
        this.on(button, 'click', () => this.selectStep(Number(button.dataset.step)));
      });
      this.on(this.q('.rv-flip'), 'click', () => this.flip());
      this.on(this.q('.rv-play'), 'click', () => this.playing ? this.stop() : this.reveal());
      this.on(this.q('.rv-pack'), 'click', () => this.selectStep(this.step === 2 ? 0 : 2));
      this.on(this.q('.rv-detail'), 'click', () => {
        const back = Math.cos(this.pose.yaw * Math.PI / 180) < 0;
        this.openArt(this.step === 0 ? (back ? 'coverBack' : 'coverFront') : this.step === 1 ? (back ? 'innerBack' : 'innerFront') : (back ? 'labelB' : 'labelA'));
      });
      this.on(this.q('.rv-close'), 'click', () => this.dialog.close());
      this.on(this.q('.rv-previous'), 'click', () => this.galleryMove(-1));
      this.on(this.q('.rv-next'), 'click', () => this.galleryMove(1));
      this.on(this.dialog, 'click', event => {
        const r = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) this.dialog.close();
      });
      this.on(this.dialog, 'keydown', event => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.galleryMove(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.galleryMove(-1); }
      });
      this.on(this.reducedQuery, 'change', event => {
        this.reduced = event.matches;
        if (this.reduced) { this.stop(); this.pose.s = this.step ? 1 : 0; this.pose.d = this.step === 2 ? 1 : 0; this.draw(); }
      });
      this.on(document, 'visibilitychange', () => { if (document.hidden) this.stop(); });
      this.on(this.stage, 'pointerdown', event => {
        if (event.button !== 0) return;
        this.stop();
        this.pointer = {
          id: event.pointerId, x: event.clientX, y: event.clientY,
          yaw: this.pose.yaw, pitch: this.pose.pitch, moved: false,
          target: event.target.closest('[data-rv-art]'), type: event.pointerType
        };
      });
      this.on(this.stage, 'pointermove', event => {
        const p = this.pointer;
        if (!p || event.pointerId !== p.id) return;
        const dx = event.clientX - p.x, dy = event.clientY - p.y;
        if (!p.moved && Math.hypot(dx, dy) < 5) return;
        if (!p.moved && p.type === 'touch' && Math.abs(dy) > Math.abs(dx) * 1.1) { this.pointer = null; return; }
        if (!p.moved) { p.moved = true; this.stage.setPointerCapture(event.pointerId); }
        this.pose.yaw = p.yaw + dx * .38;
        this.pose.pitch = clamp(p.pitch - dy * .22, -36, 36);
        this.draw();
      });
      this.on(this.stage, 'pointerup', event => {
        const p = this.pointer;
        if (!p || p.id !== event.pointerId) return;
        this.pointer = null;
        if (this.stage.hasPointerCapture(event.pointerId)) this.stage.releasePointerCapture(event.pointerId);
        if (!p.moved && p.target) this.openArt(p.target.dataset.rvArt);
        this.updateControls();
      });
      this.on(this.stage, 'pointercancel', () => { this.pointer = null; this.updateControls(); });
    }
    draw() {
      if (!this.stage) return;
      const {s, d, yaw, pitch} = this.pose;
      const w = this.stage.clientWidth, h = this.stage.clientHeight;
      const modelWidth = 368 + 336 * s;
      const modelHeight = 365 + 316 * d;
      const scale = Math.min((w - 30) / modelWidth, (h - 68) / modelHeight, 1.58);
      this.viewer.style.transform = 'translateY(' + (150 * d * scale) + 'px) scale(' + scale + ') rotateX(' + pitch + 'deg) rotateY(' + yaw + 'deg)';
      this.jacket.style.transform = 'translateX(' + (-168 * s) + 'px)';
      this.stack.style.transform = 'translateX(' + (168 * s) + 'px)';
      this.record.style.transform = 'translateY(' + (-314 * d) + 'px)';
      this.style.setProperty('--rv-light-angle', (112 - yaw * .3) + 'deg');
      this.style.setProperty('--rv-disc-light', (30 - yaw * .6) + 'deg');
      this.q('.rv-flip').textContent = Math.cos(yaw * Math.PI / 180) < 0 ? 'See front' : 'See back';
    }
    updateControls() {
      if (!this.q) return;
      this.querySelectorAll('[data-step]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.step) === this.step)));
      this.q('.rv-play').textContent = this.playing ? 'Pause' : 'Play reveal';
      this.q('.rv-pack').textContent = this.step === 2 ? 'Close vinyl' : 'Open vinyl';
      const back = Math.cos(this.pose.yaw * Math.PI / 180) < 0;
      const text = this.step === 0 ? (back ? 'Back cover' : 'Front cover') : this.step === 1 ? 'The hand-made collage inner sleeve' : 'Cover · Collage inner sleeve · Record';
      this.q('.rv-status').textContent = text;
      this.q('.rv-announcement').textContent = text;
    }
    stop() {
      this.token = (this.token || 0) + 1;
      cancelAnimationFrame(this.frame);
      if (this.resolveMotion) { const resolve = this.resolveMotion; this.resolveMotion = null; resolve(false); }
      this.playing = false;
      if (this.pose) this.step = this.pose.d > .5 ? 2 : this.pose.s > .5 ? 1 : 0;
      if (this.q) this.updateControls();
    }
    tween(to, duration, token) {
      if (token !== this.token) return Promise.resolve(false);
      const from = {...this.pose};
      if (this.reduced) { Object.assign(this.pose, to); this.draw(); return Promise.resolve(true); }
      return new Promise(resolve => {
        this.resolveMotion = resolve;
        const started = performance.now();
        const tick = now => {
          if (token !== this.token || !this.isConnected) { this.resolveMotion = null; resolve(false); return; }
          const t = clamp((now - started) / duration, 0, 1);
          const eased = t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
          for (const key of Object.keys(to)) this.pose[key] = from[key] + (to[key] - from[key]) * eased;
          this.draw();
          if (t < 1) this.frame = requestAnimationFrame(tick);
          else { this.resolveMotion = null; resolve(true); }
        };
        this.frame = requestAnimationFrame(tick);
      });
    }
    async moveTo(step, token) {
      const sleeve = step > 0 ? 1 : 0, disc = step === 2 ? 1 : 0;
      this.step = step; this.updateControls();
      if (this.pose.d > .001 && disc === 0) if (!await this.tween({d: 0}, 1200, token)) return false;
      if (Math.abs(this.pose.s - sleeve) > .001) if (!await this.tween({s: sleeve}, 1650, token)) return false;
      if (Math.abs(this.pose.d - disc) > .001) if (!await this.tween({d: disc}, 1500, token)) return false;
      return token === this.token;
    }
    async selectStep(step) {
      this.stop();
      const token = this.token;
      await this.moveTo(step, token);
      if (token === this.token) this.updateControls();
    }
    async flip() {
      this.stop();
      const token = this.token;
      await this.tween({yaw: this.pose.yaw + 180}, 1550, token);
      if (token === this.token) this.updateControls();
    }
    async reveal() {
      this.stop();
      const token = this.token;
      if (this.reduced) {
        this.pose = {s: 1, d: 1, yaw: -18, pitch: -7}; this.step = 2;
        this.draw(); this.updateControls(); return;
      }
      this.playing = true; this.updateControls();
      if (!await this.moveTo(0, token)) return;
      if (!await this.tween({yaw: -18, pitch: -7}, 1000, token)) return;
      if (!await this.moveTo(1, token)) return;
      if (!await this.tween({}, 600, token)) return;
      if (!await this.moveTo(2, token)) return;
      if (!await this.tween({}, 750, token)) return;
      if (!await this.tween({yaw: 162}, 2100, token)) return;
      if (!await this.tween({}, 1100, token)) return;
      if (!await this.tween({yaw: 342}, 2100, token)) return;
      if (token === this.token) { this.playing = false; this.pose.yaw = -18; this.draw(); this.updateControls(); }
    }
    openArt(key) {
      this.stop();
      const index = gallery.findIndex(([id]) => id === key);
      this.galleryIndex = index >= 0 ? index : 0;
      this.showArt();
      this.dialog.showModal();
    }
    galleryMove(direction) {
      this.galleryIndex = (this.galleryIndex + direction + gallery.length) % gallery.length;
      this.showArt();
    }
    showArt() {
      const [key, label] = gallery[this.galleryIndex];
      const image = this.q('.rv-detail-image');
      image.src = this.assets[key]; image.alt = 'RIELL — Hymns For The Bitter — ' + label;
      this.q('.rv-gallery-title').textContent = label;
      this.q('.rv-counter').textContent = (this.galleryIndex + 1) + ' / ' + gallery.length;
    }
  }
  customElements.define('riell-vinyl-viewer', RiellVinylViewer);
})();

(() => {
  'use strict';
  if (customElements.get('riell-vinyl-product')) return;
  const media = [
    ['coverFront', 'Front cover'], ['coverBack', 'Back cover'],
    ['innerFront', 'Inner sleeve — front'], ['innerBack', 'Inner sleeve — back']
  ];
  const tracks = [
    ['Burn Our Bridges Down', 'Antis', 'Happy For You', 'My Ghost', 'World On Fire', '25', '8 Years Old', 'I’d Rather Lose You Than My Mind'],
    ['End It', '2am', 'Villain', 'Game’s Up', 'Strangers', 'Devil', 'Poison', 'King']
  ];
  class RiellVinylProduct extends HTMLElement {
    connectedCallback() {
      if (this.active) return;
      const source = this.querySelector('[data-rp-config]');
      if (source) { try { this.config = JSON.parse(source.textContent); } catch { return; } }
      if (!this.config?.assets?.coverFront) return;
      this.active = true;
      this.abort = new AbortController();
      this.selected = 0;
      this.innerHTML = `
        <section class="rp-page" aria-label="Hymns For The Bitter vinyl">
          <div class="rp-product">
            <div class="rp-media">
              <button type="button" class="rp-photo" aria-label="Enlarge front cover"><img class="rp-hero-image" width="1300" height="1300" alt="RIELL — Hymns For The Bitter front cover"></button>
              <div class="rp-thumbnails" role="group" aria-label="Album artwork">
                ${media.map(([key,label],i)=>`<button type="button" class="rp-thumbnail" data-media="${i}" aria-label="${label}" aria-pressed="${i===0}"><img data-thumbnail="${key}" width="120" height="120" alt=""></button>`).join('')}
                <button type="button" class="rp-explore"><span class="rp-orbit" aria-hidden="true">↻</span><span>Explore<br>in 3D</span></button>
              </div>
              <p class="rp-media-caption">Front cover</p>
            </div>
            <div class="rp-info">
              <p class="rp-kicker">RIELL · 12-INCH VINYL</p>
              <h1>Hymns For<br>The Bitter</h1>
              <p class="rp-price"></p>
              
              <p class="rp-description">Sixteen songs across two sides, with a printed inner sleeve featuring RIELL’s handmade collage of photographs, illustrations and handwritten notes.</p>
              <div class="rp-purchase">
                <label class="rp-quantity-label">Quantity<input class="rp-quantity" type="number" min="1" max="10" value="1" inputmode="numeric"></label>
                <button type="button" class="rp-buy" disabled>Add to cart</button>
              </div>
              <p class="rp-shipping">Shipping details to be confirmed.</p>
              <div class="rp-details">
                <details open><summary>The vinyl</summary><ul><li>12-inch vinyl · 16 tracks</li><li>Full-colour front and back cover</li><li>Printed collage inner sleeve</li><li>RIELL eye artwork on both centre labels</li></ul></details>
                <details><summary>Tracklist</summary><div class="rp-tracks">${tracks.map((side,i)=>`<div><h3>Side ${i?'B':'A'}</h3><ol>${side.map(song=>`<li>${song}</li>`).join('')}</ol></div>`).join('')}</div></details>
              </div>
            </div>
          </div>
          <div class="rp-story">
            <div><h2>From RIELL</h2></div>
            <div><blockquote>“I wanted to create a world someone could enter that inspired them: inspired them to feel confident, powerful, worthwhile, and strong.”</blockquote></div>
          </div>
        </section>
        <dialog class="rp-explorer-dialog" aria-label="Explore the vinyl in 3D"><div class="rp-modal-heading"><h2>Inside the vinyl</h2><button type="button" class="rp-close-explorer">Close</button></div><div class="rp-viewer-mount"></div></dialog>
        <dialog class="rp-photo-dialog" aria-label="Album artwork close-up"><div class="rp-modal-heading"><h2 class="rp-zoom-title">Front cover</h2><button type="button" class="rp-close-photo">Close</button></div><img class="rp-zoom-image" width="1300" height="1300" alt=""><div class="rp-zoom-nav"><button type="button" class="rp-prev">Previous</button><span class="rp-image-count"></span><button type="button" class="rp-next">Next</button></div></dialog>`;
      const q = selector => this.querySelector(selector);
      this.q = q;
      this.photoDialog = q('.rp-photo-dialog');
      this.explorerDialog = q('.rp-explorer-dialog');
      q('.rp-price').textContent = this.config.price || 'Price to be confirmed';
      q('.rp-buy').textContent = this.config.buyLabel || 'Add to cart';
      q('.rp-shipping').textContent = this.config.shipping || 'Shipping details to be confirmed.';
      media.forEach(([key]) => { q('[data-thumbnail="'+key+'"]').src = this.config.assets[key]; });
      const on = (el, name, handler) => el.addEventListener(name, handler, {signal:this.abort.signal});
      this.querySelectorAll('[data-media]').forEach(button=>on(button,'click',()=>this.selectMedia(Number(button.dataset.media))));
      on(q('.rp-photo'),'click',()=>{ this.zoomIndex=this.selected; this.showPhoto(); this.photoDialog.showModal(); });
      on(q('.rp-close-photo'),'click',()=>this.photoDialog.close());
      on(q('.rp-prev'),'click',()=>this.movePhoto(-1));
      on(q('.rp-next'),'click',()=>this.movePhoto(1));
      on(this.photoDialog,'keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();this.movePhoto(-1);}if(event.key==='ArrowRight'){event.preventDefault();this.movePhoto(1);}});
      on(q('.rp-explore'),'click',()=>this.explore());
      on(q('.rp-close-explorer'),'click',()=>this.explorerDialog.close());
      on(this.explorerDialog,'close',()=>this.viewer?.stop());
      [this.photoDialog,this.explorerDialog].forEach(dialog=>on(dialog,'click',event=>{
        const r=dialog.getBoundingClientRect();
        if(event.target===dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))dialog.close();
      }));
      this.selectMedia(0);
    }
    disconnectedCallback(){this.abort?.abort();this.viewer?.stop();this.active=false;this.viewer=null;}
    selectMedia(index){
      this.selected=index;
      const [key,label]=media[index];
      this.q('.rp-hero-image').src=this.config.assets[key];
      this.q('.rp-hero-image').alt='RIELL — Hymns For The Bitter — '+label;
      this.q('.rp-photo').setAttribute('aria-label','Enlarge '+label.toLowerCase());
      this.q('.rp-media-caption').textContent=label;
      this.querySelectorAll('[data-media]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.media)===index)));
    }
    explore(){
      this.explorerDialog.showModal();
      if(!this.viewer){
        this.viewer=document.createElement('riell-vinyl-viewer');
        this.viewer.setAttribute('data-compact','');
        const data=document.createElement('script');data.type='application/json';data.setAttribute('data-rv-assets','');data.textContent=JSON.stringify(this.config.assets);
        this.viewer.appendChild(data);this.q('.rp-viewer-mount').appendChild(this.viewer);
      }
      requestAnimationFrame(()=>{if(this.explorerDialog.open){this.viewer.draw();this.viewer.reveal();}});
    }
    movePhoto(direction){this.zoomIndex=(this.zoomIndex+direction+media.length)%media.length;this.showPhoto();}
    showPhoto(){const [key,label]=media[this.zoomIndex];this.q('.rp-zoom-image').src=this.config.assets[key];this.q('.rp-zoom-image').alt=label;this.q('.rp-zoom-title').textContent=label;this.q('.rp-image-count').textContent=(this.zoomIndex+1)+' / '+media.length;}
  }
  customElements.define('riell-vinyl-product',RiellVinylProduct);
})();


  } catch(e) { console.error(e); }
})();
})();
